const NotFound = () => {
  return (
    <div className="flex justify-center flex-col items-center min-h-[70vh]">
      <h1 className="text-[70px]">404</h1>
      <p className="text-[20px]">Page Not Found</p>
    </div>
  );
};

export default NotFound;